export const ACCESS_TOKEN = 'accessToken';

export const COLORS = {
  WHITE: '#ffffff',
  GRAY100: '#D0D5DD',
  SECONDARY: '#5532FA',
  SUCCESS: '#49BC80',
};

export const NETWORK_ERROR = 'Network Error';
export const ERROR_STATUS_500 = 5;
export const ERROR_STATUS_401 = 401;
export const ERROR_STATUS_404 = 404;
export const ERROR_MESSAGE = 'Something went wrong!';

export const CHATBOT_ROLE = {
  USER: 'user',
  ASSISTANT: 'assistant',
};

export const FIELD_TYPES = {
  UPLOAD: 'upload',
  NUMBER: 'number',
  DROPDOWN: 'dropdown',
  FILE: 'file',
  TEL: 'tel',
  EMAIL: 'email',
  TEXTAREA: 'textarea',
  DATE: 'date',
  CONSENT: 'consent',
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const MAX_LENGTH_LIMIT = 100;

export const DELETED = 'DELETED';

export const CHAT_WINDOW_OFFSET = 68;

export const PREVIEW_OFFSET = 50;

export const SMALL_MOBILE_BREAKPOINT = 416;

export const MOBILE_BREAKPOINT = 576;

export const INPAGE_HEADING_WEB_TEXT_SIZE = 24;
export const INPAGE_HEADING_MOBILE_TEXT_SIZE = 22;
export const INPAGE_SUB_HEADING_WEB_TEXT_SIZE = 20;
export const INPAGE_SUB_HEADING_MOBILE_TEXT_SIZE = 18;

export const CHATBOT_FAQ_PADDING = 200;

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  INVALID_EMAIL: 'Invalid email format',
  NUMERIC_ONLY: 'Only numbers allowed',
  FILE_TOO_LARGE: 'File too large. Max 10MB allowed.',
  UPLOAD_ERROR: 'Error occurred while uploading file.',
  SUBMISSION_ERROR: 'Something went wrong during submission.',
  SUBMISSION_SUCCESS: 'Thank you for your submission!',
  DUPLICATE_FILE: 'Duplicate files are not allowed!',
};

export const ACTIVE = 'ACTIVE';
export const INACTIVE = 'INACTIVE';

export const INPAGE_CHATBOT_MESSAGE_TYPES = {
  ERROR: 'INPAGE_CHATBOT_ERROR',
  HEIGHT: 'INPAGE_CHATBOT_HEIGHT',
};

export const DATE_FORMAT = {
  STANDARD_TIME: 'HH:mm',
  RANGE_DATE: 'DD/MM/YYYY',
  STANDARD_DATE: 'YYYY-MM-DD',
};


export const RESET = 'reset';

export const POSITION_OFFSET = '36px';

export const CLOSE = 'close';
export const RESET_CHAT = 'RESET_CHAT';

export const SUBMIT_FORM_TIMEOUT = 3000;

export const NEWSLETTER_NOTE_DURATION = 8000;

export const ENTER = 'Enter';

export const LANGUAGES = [
  { code: 'en', label: 'EN' },
  { code: 'fi', label: 'FI' },
  { code: 'sv', label: 'SV' },
  { code: 'de', label: 'DE' },
];

export const LANGUAGES_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'fi', label: 'Suomi' },
  { value: 'sv', label: 'Svenska' },
  { value: 'de', label: 'Deutsch' },
];

export const ENGLISH = 'English';
export const FINNISH = 'Finnish';

export const POPOVER_HEIGHT = 320;

export const PRIMITIVE_TYPES = {
  STRING: 'string',
};

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DEFAULT_INPAGE_HEIGHT = 700;
export const DEFAULT_INPAGE_PADDING = 40;
